/* CUSTOM - Complete the Set / Complete Your Bag (PDP cross-sell)
   <complete-the-set> custom element:
   - live-updates the running total as checkboxes toggle
   - "Add all to cart" adds every checked item in one /cart/add.js call, then
     refreshes the header + cart drawer sections and opens the drawer,
     mirroring the theme's own add-to-cart flow (main.js). */
(function () {
  if (customElements.get('complete-the-set')) return;

  const money = (cents) => {
    // Reuse the theme money formatter when present; fall back to a plain $ format.
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  };

  class CompleteTheSet extends HTMLElement {
    connectedCallback() {
      this.totalEl = this.querySelector('[data-cts-total]');
      this.addBtn = this.querySelector('[data-cts-add]');
      this.addText = this.querySelector('[data-cts-add-text]');
      this.errorEl = this.querySelector('.cts__error');
      this.checks = Array.from(this.querySelectorAll('.cts__check'));

      this.onChange = this.updateTotal.bind(this);
      this.onAdd = this.handleAdd.bind(this);
      this.checks.forEach((c) => c.addEventListener('change', this.onChange));
      this.addBtn && this.addBtn.addEventListener('click', this.onAdd);
      this.updateTotal();
    }

    disconnectedCallback() {
      this.checks.forEach((c) => c.removeEventListener('change', this.onChange));
      this.addBtn && this.addBtn.removeEventListener('click', this.onAdd);
    }

    /** Live variant id for the main row = whatever the PDP form currently has selected. */
    mainVariantId() {
      const input = document.querySelector('.js-product-form [name="id"]');
      return input && input.value ? input.value : null;
    }

    selectedItems() {
      return this.checks
        .filter((c) => c.checked)
        .map((c) => {
          let id = c.dataset.variantId;
          if (c.dataset.main === 'true') id = this.mainVariantId() || id;
          return { id, price: parseInt(c.dataset.price, 10) || 0 };
        })
        .filter((it) => it.id);
    }

    updateTotal() {
      const items = this.selectedItems();
      const total = items.reduce((sum, it) => sum + it.price, 0);
      if (this.totalEl) this.totalEl.textContent = money(total);
      if (this.addText) {
        this.addText.textContent = items.length <= 1 ? 'Add to cart' : `Add all ${items.length} to cart`;
      }
      if (this.addBtn) this.addBtn.disabled = items.length === 0;
    }

    setError(msg) {
      if (!this.errorEl) return;
      if (msg) {
        this.errorEl.textContent = msg;
        this.errorEl.hidden = false;
      } else {
        this.errorEl.textContent = '';
        this.errorEl.hidden = true;
      }
    }

    async handleAdd() {
      const items = this.selectedItems().map((it) => ({ id: it.id, quantity: 1 }));
      if (!items.length) return;
      this.setError('');
      this.addBtn.classList.add('is-loading');
      this.addBtn.setAttribute('aria-disabled', 'true');

      const sectionsToUpdate = ['page-header', 'cart-drawer']
        .map((sel) => document.querySelector(sel))
        .filter((el) => el);
      const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId).filter(Boolean);

      const body = {
        items,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      };

      try {
        const res = await fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(body)
        });
        const data = await res.json();
        if (!res.ok) {
          throw new Error((data && (data.description || data.message)) || 'Could not add to cart.');
        }

        // Refresh header + cart drawer sections, then open the drawer (same as main.js).
        if (data.sections) {
          sectionsToUpdate.forEach((el) => {
            if (data.sections[el.dataset.sectionId] && typeof el.updateFromCartChange === 'function') {
              el.updateFromCartChange(data.sections[el.dataset.sectionId]);
            }
          });
        }
        this.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { items } }));

        const drawer = document.querySelector('.js-cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open(this.addBtn);
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }

        this.addBtn.classList.remove('is-loading');
        this.addBtn.classList.add('is-success');
        setTimeout(() => this.addBtn.classList.remove('is-success'), 2000);
      } catch (err) {
        this.addBtn.classList.remove('is-loading');
        this.setError(err.message || 'Could not add to cart. Please try again.');
      } finally {
        this.addBtn.removeAttribute('aria-disabled');
      }
    }
  }

  customElements.define('complete-the-set', CompleteTheSet);
})();
